export enum Role {
    Staff = 'Staff',
    Admin = 'Admin',
    AdminOrder = 'AdminOrder'
}
